import { render, staticRenderFns } from "./RegisterFooter.vue?vue&type=template&id=405a8002&scoped=true&"
import script from "./RegisterFooter.vue?vue&type=script&lang=js&"
export * from "./RegisterFooter.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFooter.vue?vue&type=style&index=0&id=405a8002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405a8002",
  null
  
)

export default component.exports